export enum ShowDS {
  Cliente = 1,
  Corretor = 2,
  Nenhum = 3,
  PortaldoRH = 4,
  PortalDoColaborador = 5,
}
